import { render } from "./FiltersSmall.vue?vue&type=template&id=cddea05a&ts=true"
import script from "./FiltersSmall.vue?vue&type=script&lang=ts"
export * from "./FiltersSmall.vue?vue&type=script&lang=ts"

import "./FiltersSmall.vue?vue&type=style&index=0&id=cddea05a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__